/**
 * 首页 Hero 轮播 API
 */
import { apiRequest } from './client'
import type { SilkHomeCarouselResponse, SilkHomePage, SilkHomeSite } from './types'

export const homeApi = {
  carousel: () =>
    apiRequest<SilkHomeCarouselResponse>('/api/v1/home/carousel', { auth: false }),
  site: () =>
    apiRequest<SilkHomeSite>('/api/v1/home/site', { auth: false }),
  page: () =>
    apiRequest<SilkHomePage>('/api/v1/home/page', { auth: false }),
}
